<template>
<div>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <component v-bind:is="ReportCustomer.customerMenuIndex"></component>
    </div>
  </div>
</div>
</template>

<script>
import ErpTreeStatus from "../Common/erp-tree-status";
export default {
  name: "ReportCustomer",
  components: {
    ErpTreeStatus,
    'CustomerList': () => import('./components/CustomerList.vue'),
    'CustomerMain': () => import('./components/CustomerMain.vue'),
    'CustomerHouse': () => import('./components/CustomerHouse.vue'),
    'CustomerHouseChange': () => import('./components/CustomerHouseChange.vue'),
    'HouseMoveInfo': () => import('./components/HouseMoveInfo.vue'),
    'FitmentList': () => import('./components/FitmentList.vue'),
    'HouseRoomStatus': () => import('./components/HouseRoomStatus.vue'),
    'HouseRoomStatusMoney': () => import('./components/HouseRoomStatusMoney.vue'),
  },
  provide(){
    return{
      ReportCustomer:this.ReportCustomer
    }
  },
  data(){
    return{
      ReportCustomer:{
        customerMenuIndex:"CustomerMain",
        project_id:0,
        house_name:"",
        house_id:0
      }

    }
  },
  methods:{
    nodeClick(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');
      this.ReportCustomer.project_id = data.tree[0].pindex_id;
      this.ReportCustomer.house_name = tree_str;
      this.ReportCustomer.house_id = data.tree[data.tree.length - 1].house_id;
      // this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.d-flex {
  margin: 10px;
  display: flex;

  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
    overflow-x:hidden;


  }
}




</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/ReportCustomer.vue